import React from 'react';
import { Grid, Typography, Box, List, ListItem, ListItemText, Paper, Button } from '@mui/material';
import { getDictionary, getField } from '@/app/utils/translation/translation';
import { getSvg } from '@/app/utils/svgUtils';


export default function TakingControl({ isMobile, language, translations, contactusRef, scrollToSection, }: { isMobile: boolean, language: any, translations: any, contactusRef: any, scrollToSection: any }) {
    const dictionary = getDictionary(translations, 'taking-control', language);
    const isArabic = language === 'arabic';

    return (
        <>
            <Box className="section-light-purple-bg" style={{ width: "100%", display: "flex", justifyContent: isMobile ? "space-between" : "center" }}>
                <Grid container spacing={isMobile ? 2 : 4} alignItems="center" padding={isMobile ? "0px " : "30px"} style={{ width: isMobile ? "100%" : "80%" }}>
                    <Grid item xs={12} md={6} >
                        <Paper elevation={3} className='paper-style' sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                            <div >
                                <div style={{ position: 'relative', zIndex: 0 }}>
                                    <Typography paragraph fontWeight="bold" fontSize={isMobile ? "20px" : "25px"} sx={{ color: "var(--text-primary)" }} fontFamily={"Century Gothic"}>
                                        {getField(dictionary, 'title', language)}
                                    </Typography>
                                </div>
                                <div style={{ position: 'relative', zIndex: -1 }}>
                                    {getSvg('arrowCircleIcon', { yellow: 'var(--accent-secondary)', darkPurple: 'var(--accent-primary)' }, { width: 80, height: 80 }, { position: 'absolute', transform: isArabic ? "translate(-5rem , -5rem)" : "translate(-1rem , -5rem)" })}
                                </div>
                            </div>

                            <List sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                <ListItem disablePadding sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                    <ListItemText
                                        primary={
                                            <span style={{ fontWeight: "bold", color: 'var(--accent-primary)', fontSize: "17px" }}>
                                                <span style={{ color: 'var(--accent-secondary)' }}>&#10004; </span>
                                                {getField(dictionary, 'list-title-one', language)}
                                            </span>
                                        }
                                        secondary={
                                            <span style={{ color: "var(--text-primary)", opacity: 1, letterSpacing: isArabic ? ' ' : "1px", fontSize: "17px" }}>
                                                {getField(dictionary, 'list-item-one', language)}
                                            </span>
                                        }
                                    />
                                </ListItem>
                                <ListItem disablePadding sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                    <ListItemText
                                        primary={
                                            <span style={{ fontWeight: "bold", color: 'var(--accent-primary)', fontSize: "17px" }}>
                                                <span style={{ color: 'var(--accent-secondary)' }}>&#10004; </span>
                                                {getField(dictionary, 'list-title-two', language)}
                                            </span>
                                        }
                                        secondary={
                                            <span style={{ color: "var(--text-primary)", opacity: 1, letterSpacing: isArabic ? ' ' : "1px", fontSize: "17px" }}>
                                                {getField(dictionary, 'list-item-two', language)}
                                            </span>
                                        }
                                    />
                                </ListItem>
                                <ListItem disablePadding sx={{ textAlign: isArabic ? 'right' : 'left' }}>
                                    <ListItemText
                                        primary={
                                            <span style={{ fontWeight: "bold", color: 'var(--accent-primary)', fontSize: "17px" }}>
                                                <span style={{ color: 'var(--accent-secondary)' }}>&#10004;</span>
                                                {getField(dictionary, 'list-title-three', language)}
                                            </span>
                                        }
                                        secondary={
                                            <span style={{ color: "var(--text-primary)", opacity: 1, letterSpacing: isArabic ? ' ' : "1px", fontSize: "17px" }}>
                                                {getField(dictionary, 'list-item-three', language)}
                                            </span>
                                        }
                                    />
                                </ListItem>
                            </List>
                            <Button
                                variant='contained'
                                sx={{
                                    backgroundColor: "var(--accent-secondary)",
                                    color: "black",
                                    marginTop: "10px",
                                    transition: 'background-color 0.3s ease',
                                    '&:hover': {
                                        backgroundColor: "var(--accent-primary)",
                                    },
                                }}
                            >
                                <a href="#contact-us" onClick={() => scrollToSection(contactusRef)} style={{ textDecoration: 'none', color: 'black', fontSize: '15px' }}>
                                    {getField(dictionary, 'start-taking-control', language)}
                                </a>

                            </Button>
                        </Paper>
                    </Grid>

                    {!isMobile && (
                        <Grid item xs={12} md={6} >
                            <Box display="flex" justifyContent="center">
                                <img src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/webp-images/takeControl.webp`} width="100%" height="auto" alt="Take Control" loading="lazy" />
                            </Box>
                        </Grid>
                    )}

                    {isMobile && (
                        <Grid item xs={12} md={6} >
                            <Box display="flex" justifyContent="center">
                                <img src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/webp-images/takeControl.webp`} loading="lazy" width="100%" height="auto" alt="Take Control" style={{ maxWidth: '100%', borderRadius: '10px' }} />
                            </Box>
                        </Grid>
                    )}
                </Grid>
            </Box>

        </>
    );
}
